import React from 'react';
import { useState } from 'react';
import { Dialog, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import PrimaryButton from '../../../../../../Generic/Buttons/PrimaryButton';
import SecondaryButton from '../../../../../../Generic/Buttons/SecondaryButton';
import Grow from '@mui/material/Grow';
import ThumbnailsGrid from '../ThumbnailsGrid/ThumbnailsGrid';

const Root = styled(Dialog)(({ theme }) => ({ width: '100%' }));

const Paper = styled(Grid)(({ theme }) => ({
	width: '100%',
	backgroundColor: theme.palette.background.secondary,
	display: 'flex',
	flexDirection: 'column'
}));

const Header = styled(Grid)(({ theme }) => ({
	width: '100%',
	padding: '20px 30px',
	maxHeight: 'calc(100dvh - 63.5px)',
	display: 'flex',
	justifyContent: 'space-between'
}));

const Body = styled(Grid)(({ theme }) => ({
	width: '100%',
	backgroundColor: '#FFF',
	padding: '35px',
	maxHeight: 'calc(100dvh - 123.5px)',
	display: 'flex',
	flexDirection: 'column',
	flex: 1,
	overflow: 'auto'
}));

const ContentContainer = styled(Grid)(({ theme }) => ({
	width: '100%',
	padding: '20px',
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center'
}));

const ActionBar = styled(Grid)(({ theme }) => ({
	width: '100%',
	padding: '12px 15px',
	position: 'absolute',
	bottom: 0,
	backgroundColor: '#FFF',
	borderTop: `solid 1px ${theme.palette.separator.primary}`,
	display: 'flex',
	justifyContent: 'space-between',
	zIndex: 300
}));

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Grow ref={ref} {...props} />;
});

function ImageSelector({ images, thumbnail, setThumbnail, open, close }) {
	const [selected, setSelected] = useState(thumbnail);

	/**
	 * Set the gallery thumbnail to the selected image.
	 */
	const onSelect = async () => {
		await setThumbnail(selected);
		close();
	};

	return (
		<Root
			open={open}
			TransitionComponent={Transition}
			maxWidth={false}
			PaperProps={{ sx: { width: '80%', height: '100%', borderRadius: '20px' } }}
		>
			<Paper>
				<Body>
					<ThumbnailsGrid images={images} selected={selected} setSelected={setSelected} />
				</Body>
				<ActionBar>
					<SecondaryButton onClick={close}>Cancel</SecondaryButton>
					<PrimaryButton onClick={onSelect}>Select</PrimaryButton>
				</ActionBar>
			</Paper>
		</Root>
	);
}

export default ImageSelector;
